module.exports = __webpack_public_path__ + "static/media/ColumnCellFlotation_1.0399eca5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/simulator/ColumnCellFlotation_1.jpg
// module id = 419
// module chunks = 0